import './styles.css'

import React from 'react'
import { Button, Message } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { DAY_OPTIONS } from '../../../utils/kegCollectionFormUtils'
import { ABBREVIATED_DAYS_LOCALIZED_STRINGS } from '../../../../../../constants'

const formatLabel = day => ABBREVIATED_DAYS_LOCALIZED_STRINGS.find(d => d[day])?.[day] || day

function KegCollectionAvailableDays(props) {
  const {
    days,
    formValues,
    isDisabled,
    onClick,
    validationErrors,
    showValidationErrors = true,
  } = props
  const { t: translate } = useTranslation()
  const allDays = days || DAY_OPTIONS
  return (
    <>
      <Button.Group
        toggle
        size="small"
        className="keg-collection-available-days"
        style={{ display: 'flex', gap: 1 }}
      >
        {allDays.map(day => {
          const active = formValues.availableDays[day]
          return (
            <Button
              key={day}
              type="button"
              active={active}
              onClick={() => !isDisabled && onClick(day, !active)}
              disabled={isDisabled}
              style={{ width: '20%' }}
            >
              {translate(formatLabel(day))}
            </Button>
          )
        })}
      </Button.Group>
      {showValidationErrors && validationErrors.availableDays && (
        <Message
          negative
          size="small"
          style={{ marginTop: 10 }}
          content={validationErrors.availableDays}
        />
      )}
    </>
  )
}

export default React.memo(KegCollectionAvailableDays)
